import { useQuery } from "@tanstack/react-query";
import { getPaymentRequests } from "../api/payments";

interface PaymentRequestParams {
  client_id?: number;
  payment_status?: string;
  limit?: number;
  offset?: number;
}

export const useStripePayments = (params: PaymentRequestParams) => {
  return useQuery<any>({
    queryKey: ["payments", params],
    queryFn: () => getPaymentRequests(params),
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000),
  });
};
